/**
 * GetActiveCampaignsUseCase
 * Loads active campaigns (startDate <= now) and remaps them to entities.
 *
 * Flutter source of truth:
 * - lib/data/repository/campaigns_repository_impl.dart:8-11 — getActiveCampaigns()
 *   delegates to the data source and returns the remapped list.
 * - lib/presentation/screens/campaigns/bloc/campaigns_bloc.dart:37-41 — the
 *   standalone screen's only load-time repository call.
 */

import { CampaignsService } from '@/domain/services/campaign/campaignsService';
import { CampaignRemapper } from '@/domain/remappers/campaign/campaignRemapper';
import type { CampaignEntity } from '@/domain/entities/campaign/campaignEntity';

export class GetActiveCampaignsUseCase {
  private campaignsService: CampaignsService;

  constructor() {
    this.campaignsService = CampaignsService.getInstance();
  }

  async execute(): Promise<CampaignEntity[]> {
    const items = await this.campaignsService.getActiveCampaigns();
    return CampaignRemapper.fromDtoList(CampaignRemapper.fromJsonList(items));
  }
}

export const createGetActiveCampaignsUseCase = () =>
  new GetActiveCampaignsUseCase();
